import React from 'react';

import { Button, Stack, Typography } from '@mui/material';

import { lensChangeFailure, useLensView } from '~/hooks/apis/reporting/useLensChange';

import type { LensView } from '~/types/leLens';

export default function LensViewStrip({
  lensId,
  view,
  onMakeCopy,
}: {
  lensId: string;
  view: LensView;
  onMakeCopy: () => void;
}) {
  const change = useLensView(lensId);
  const count = view.changes.length;
  const noLongerApplies = view.changes.flatMap((entry) => entry.noLongerApplies);
  return (
    <Stack
      data-testid="lens-view-strip"
      spacing={0.5}
      sx={{ mt: 1.5, mb: 1, px: 1.5, py: 0.75, bgcolor: 'action.hover', borderRadius: 1 }}
    >
      <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1}>
        <Typography sx={{ fontSize: 13, fontWeight: 600, flex: 1 }}>
          Your view · {count} {count === 1 ? 'change' : 'changes'}
        </Typography>
        <Button disabled={change.isPending} onClick={onMakeCopy} size="small">
          Make a copy
        </Button>
        <Button disabled={change.isPending} onClick={() => change.mutate({ action: 'reset' })} size="small">
          Reset
        </Button>
      </Stack>
      {noLongerApplies.map((target) => (
        <Typography key={target} sx={{ fontSize: 12.5, color: 'text.secondary' }}>
          Your change to {target} no longer applies: the owner changed it.
        </Typography>
      ))}
      {change.error && (
        <Typography sx={{ fontSize: 12.5, color: 'error.main' }}>{lensChangeFailure(change.error)}</Typography>
      )}
    </Stack>
  );
}
